import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { useLang, localizeDeep } from "@/context/LanguageContext";

const CMSContext = createContext(null);

const EMPTY = {
  events: [], initiatives: [], books: [], panels: [], partners: [], timeline: [],
  stats: [], quotes: [], campaigns: [], media: [], gallery: [], pages: [], board: [], articles: [], sections: [], settings: {},
};

export function CMSProvider({ children }) {
  const [raw, setRaw] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const { lang } = useLang();

  const load = useCallback(() => {
    api
      .get("/public/bootstrap")
      .then((r) => setRaw({ ...EMPTY, ...r.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const data = useMemo(() => (lang === "fr" ? localizeDeep(raw) : raw), [raw, lang]);

  return <CMSContext.Provider value={{ data, loading, reload: load }}>{children}</CMSContext.Provider>;
}

export function useCMS() {
  return useContext(CMSContext);
}

export function usePage(key) {
  const { data } = useCMS();
  return (data.pages || []).find((p) => p.key === key) || {};
}

export function useStat(key) {
  const { data } = useCMS();
  const s = (data.stats || []).find((x) => x.key === key);
  return s ? s.value : "";
}

export function useSection(key) {
  const { data } = useCMS();
  return (data.sections || []).find((s) => s.key === key) || {};
}
